import { Check } from "lucide-react";
import { Button } from "@/components/ui/button";
import { motion } from "framer-motion";
import { useLocale } from "@/i18n/LocaleContext";
import { openCalendly } from "@/lib/calendly";

const PricingSection = () => {
  const { t, locale } = useLocale();

  const features = [
    t("pricing.feature1"),
    t("pricing.feature2"),
    t("pricing.feature3"),
    t("pricing.feature4"),
    t("pricing.feature5"),
    t("pricing.feature6"),
  ];

  return (
    <section id="pricing" className="py-16 md:py-24 bg-[#F8F8F8]">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6 }}
          className="max-w-2xl mx-auto"
        >
          <div className="bg-background rounded-2xl border border-border/50 shadow-xl p-8 md:p-12 text-center">
            <h2 className="text-2xl md:text-3xl font-extrabold text-primary mb-2">
              {t("pricing.heading")}
            </h2>
            <p className="text-muted-foreground mb-8">
              {locale === "en"
                ? "Transparent pricing. No hidden costs."
                : locale === "fr"
                  ? "Tarifs transparents. Aucun frais caché."
                  : "Precios transparentes. Sin sorpresas."}
            </p>

            <div className="mb-8">
              <div className="flex items-baseline justify-center gap-2 mb-1">
                <span className="text-5xl md:text-6xl font-extrabold text-primary">390€</span>
                <span className="text-lg text-muted-foreground font-medium">
                  {t("pricing.ii")}
                </span>
              </div>
              <div className="text-muted-foreground text-base md:text-lg">
                {t("pricing.tax")} <span className="font-semibold text-foreground">38,28€</span>
              </div>
            </div>

            <ul className="text-left space-y-4 mb-10 max-w-md mx-auto">
              {features.map((feature, index) => (
                <motion.li
                  key={index}
                  initial={{ opacity: 0, x: -10 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: index * 0.08, duration: 0.4 }}
                  className="flex items-start gap-3"
                >
                  <span className="mt-0.5 inline-flex h-5 w-5 items-center justify-center rounded-full bg-accent/15 text-accent flex-shrink-0">
                    <Check className="h-3 w-3" />
                  </span>
                  <span className="text-foreground text-base">{feature}</span>
                </motion.li>
              ))}
            </ul>

            <Button
              onClick={() => openCalendly(locale)}
              className="bg-accent hover:bg-accent/90 text-accent-foreground font-bold text-lg px-10 py-6 rounded-xl shadow-lg hover:shadow-xl transition-all hover:-translate-y-0.5"
            >
              {t("pricing.cta")}
            </Button>

            <p className="mt-4 text-sm text-muted-foreground">
              {t("pricing.note")}
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default PricingSection;
